import { toast } from "react-toastify";
import ToastErrorContent from "@odm/components/common/ToastErrorContent";

export const asynchronousServiceCall = async (
  client,
  query,
  variables,
  fetchPolicy
) => {
  try {
    const { data } = await client.query({
      query: query,
      variables: variables,
      fetchPolicy: fetchPolicy ?? "cache-first",
    });
    return data;
  } catch (error) {
    console.log("asynchronousServiceCall error", { error });
    toast.error(<ToastErrorContent errors={error} />, {
      autoClose: false,
    });
  }
};

export const unblockedAsynchronousServiceCall = async (
  client,
  query,
  variables
) => {
  try {
    const response = await client.query({
      query: query,
      variables: variables,
      errorPolicy: "all", //This gives the ability to return data regardless there are an errors or not as sometimes GraphQL returns data alongside with errors
    });

    if (response?.errors?.length) {
      console.log("GraphQL errors", { errors: response.errors });
      response.errors?.map((err) => {
        toast.error(<ToastErrorContent errors={err} />, {
          autoClose: false,
        });
      });
    }

    return response.data;
  } catch (error) {
    console.log("unblockedAsynchronousServiceCall error", { error });
    toast.error(<ToastErrorContent errors={error} />, {
      autoClose: false,
    });
  }
};

export const asynchronousServiceMutation = async (
  client,
  mutation,
  variables
) => {
  try {
    const { data } = await client.mutate({
      mutation: mutation,
      variables: variables,
    });
    return data;
  } catch (error) {
    toast.error(<ToastErrorContent errors={error} />, {
      autoClose: false,
    });
  }
};
